import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { PropTypes } from 'prop-types';
import { ContainerBreadcrumb, UlBreadcrumb } from './breadcrumb.styles';

export default class Breadcrumb extends PureComponent {
  render() {
    const { links, actualLink } = this.props;
    const hasCurrentProp = Boolean(actualLink && String(actualLink).trim());

    return (
      <ContainerBreadcrumb aria-label="Navegação estrutural">
        <UlBreadcrumb className="fc-breadcrumb">
          <li>
            <Link to="/intranet/dashboard">Início</Link>
          </li>
          {links.map((element, index) => {
            const isLast = index === links.length - 1;
            const noLink =
              element.link === undefined ||
              element.link === null ||
              element.link === '';
            const isCurrent = !hasCurrentProp && isLast && noLink;

            if (noLink) {
              return (
                <li
                  key={element.label || `crumb-${index}`}
                  className={isCurrent ? 'breadcrumb-current' : undefined}
                  aria-current={isCurrent ? 'page' : undefined}
                >
                  {element.label}
                </li>
              );
            }
            return (
              <li key={element.link}>
                <Link to={element.link}>{element.label}</Link>
              </li>
            );
          })}
          {hasCurrentProp && (
            <li className="breadcrumb-current" aria-current="page">
              {actualLink}
            </li>
          )}
        </UlBreadcrumb>
      </ContainerBreadcrumb>
    );
  }
}

Breadcrumb.propTypes = {
  links: PropTypes.array.isRequired,
  actualLink: PropTypes.string
};

Breadcrumb.defaultProps = {
  actualLink: ''
};
